import React, { FunctionComponent, Fragment, useContext } from "react";
import { TopBar } from "../../components/topbar/top-bar";
import { Background } from "../../components/container/background";
import { NutritionContextProvider } from "./context/nutrition-context";
import { NutritionPageContent } from "./nutrition-page-content";
import { AnswerContextProvider } from "./answer/context/answer-context";
import { NutritionContext } from "./context/nutrition-context";
import { MenuItemCategory, MenuItemSubcategory } from "../../models/types/category-types";

interface INutritionPageProps {}

const NutritionContentWrapper: FunctionComponent<INutritionPageProps> = (props) => {
  const { children } = props;
  const { changeActiveCategories } = useContext(NutritionContext);

  return (
    <>
      <TopBar
        onLogoClick={() => changeActiveCategories(MenuItemCategory.RECOMMENDATIONS, MenuItemSubcategory.OVERVIEW)}
      />
      {children}
    </>
  );
};

export const NutritionPage: FunctionComponent<INutritionPageProps> = (props) => {
  return (
    <Fragment>
      <Background showSkeleton>
        <NutritionContextProvider>
          <AnswerContextProvider>
            <NutritionContentWrapper>
              <NutritionPageContent />
            </NutritionContentWrapper>
          </AnswerContextProvider>
        </NutritionContextProvider>
      </Background>
    </Fragment>
  );
};
